module.exports = __webpack_public_path__ + "img/grid-1.eca38d53.svg";